import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon, InstagramIcon } from 'lucide-react';
import { BuyButton } from './BuyButton';
import { MODULES } from '../data/content';
export function Modules() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const shouldReduceMotion = useReducedMotion();
  const activeModule = MODULES[activeIndex];
  function goTo(index: number, nextDirection: number) {
    setDirection(nextDirection);
    setActiveIndex((index + MODULES.length) % MODULES.length);
  }
  function showPrevious() {
    goTo(activeIndex - 1, -1);
  }
  function showNext() {
    goTo(activeIndex + 1, 1);
  }
  return <section className="px-5 py-10" data-id="element-161" data-mp="1i3b1r5nls8wy">
      <div className="mx-auto max-w-md" data-id="element-162" data-mp="2omixgtyd2dgg">
        <h2 className="text-center font-anton text-2xl leading-tight text-white sm:text-3xl" data-id="element-163" data-mp="2olhkgjxsbgw3">
          Para eso hicimos{' '}
          <span className="text-[#F5C518]" data-id="element-164" data-mp="1v2uzdu4zk0j">HYROX Definitivo 360 Coach</span>
        </h2>
        <p className="mt-3 text-center text-sm text-neutral-400" data-id="element-165" data-mp="1sqgxbri1tsr">
          Desliza para descubrir los 7 tomos del sistema.
        </p>

        <div className="mt-6 overflow-hidden rounded-2xl border border-[#F5C518]/35 bg-[#111]/95 shadow-xl" role="region" aria-roledescription="carrusel" aria-label="Tomos incluidos en HYROX Definitivo 360 Coach" data-id="element-166" data-mp="3oyzmjghdaxd9">
          <div className="flex items-center gap-3 border-b border-white/10 px-4 py-3" data-id="element-167" data-mp="3f3foanfbzmlc">
            <span className="flex h-9 w-9 items-center justify-center rounded-full border border-[#F5C518]/50 bg-[#F5C518]/10 font-oswald text-xs font-700 text-[#F5C518]" data-id="element-168" data-mp="3a8s1cszz708v">
              H360
            </span>
            <div className="min-w-0 flex-1" data-id="element-169" data-mp="318dg1tn0hl5d">
              <p className="text-[13px] font-700 text-white" data-id="element-170" data-mp="2wa249dd5p0ki">El sistema por dentro</p>
              <p className="text-[11px] text-neutral-400" data-id="element-171" data-mp="2rbqsgx3awfzn">Tomos incluidos</p>
            </div>
            <InstagramIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-172" data-mp="2hnvacyrgidyp" />
          </div>

          <div className="relative min-h-[224px]" data-id="element-173" data-mp="2mo0uzuzb707a">
            <AnimatePresence initial={false} mode="wait" custom={direction} data-id="element-174" data-mp="2moss5a8k15zo">
              <motion.article key={activeModule.title} custom={direction} initial={shouldReduceMotion ? false : {
              opacity: 0,
              x: direction > 0 ? 34 : -34
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={shouldReduceMotion ? undefined : {
              opacity: 0,
              x: direction > 0 ? -34 : 34
            }} transition={{
              duration: 0.25,
              ease: [0.25, 1, 0.5, 1]
            }} drag={shouldReduceMotion ? false : 'x'} dragConstraints={{
              left: 0,
              right: 0
            }} dragElastic={0.16} onDragEnd={(_, info) => {
              if (info.offset.x < -55 || info.velocity.x < -450) {
                showNext();
              }
              if (info.offset.x > 55 || info.velocity.x > 450) {
                showPrevious();
              }
            }} className="absolute inset-0 cursor-grab px-5 py-5 active:cursor-grabbing" aria-label={`${activeModule.title}. ${activeModule.description}`} data-id="element-175" data-mp="28p1ghg5ig1ou">
                <div className="flex items-center justify-between" data-id="element-176" data-mp="tqvujs4czewu">
                  <span className="text-3xl" aria-hidden="true" data-id="element-177" data-mp="oslylfat8aa6">
                    {activeModule.emoji}
                  </span>
                  <span className="rounded-full border border-[#F5C518]/30 bg-[#F5C518]/10 px-3 py-1 font-oswald text-[11px] font-700 uppercase tracking-wide text-[#F5C518]" data-id="element-178" data-mp="13q4io4cjlzba">
                    Tomo {activeIndex + 1} de {MODULES.length}
                  </span>
                </div>

                <div className="mt-5 border-l-2 border-[#F5C518] pl-4" data-id="element-179" data-mp="2a4dlr6zcuxva">
                  <h3 className="font-oswald text-2xl font-700 leading-tight text-white" data-id="element-180" data-mp="jojor6c35983">
                    {activeModule.title}
                  </h3>
                  <p className="mt-3 max-w-sm text-[15px] leading-relaxed text-neutral-300" data-id="element-181" data-mp="oopnt7kopy07">
                    {activeModule.description}
                  </p>
                </div>
              </motion.article>
            </AnimatePresence>
          </div>

          <div className="flex items-center justify-between border-t border-white/10 px-4 py-3" data-id="element-182" data-mp="12lupkvdd8apn">
            <button type="button" onClick={showPrevious} aria-label="Ver tomo anterior" className="flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-white transition-colors hover:border-[#F5C518] hover:text-[#F5C518] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F5C518]" data-id="element-183" data-mp="17kfs51g3b6h9">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-184" data-mp="1qd05fajb32zy" />
            </button>

            <div className="flex items-center gap-1.5" aria-label={`Tomo ${activeIndex + 1} de ${MODULES.length}`} data-id="element-185" data-mp="20h6r044pjqs9">
              {MODULES.map((module, index) => <button key={module.title} type="button" onClick={() => goTo(index, index > activeIndex ? 1 : -1)} aria-label={`Ver ${module.title}`} aria-current={index === activeIndex ? 'true' : undefined} className={`h-2 rounded-full transition-[width,background-color] duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F5C518] focus-visible:ring-offset-2 focus-visible:ring-offset-[#111] ${index === activeIndex ? 'w-5 bg-[#F5C518]' : 'w-2 bg-white/25'}`} data-id="element-186" data-mp="1qiqzw15okhir" data-mpi={index} />)}
            </div>

            <button type="button" onClick={showNext} aria-label="Ver siguiente tomo" className="flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-white transition-colors hover:border-[#F5C518] hover:text-[#F5C518] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F5C518]" data-id="element-187" data-mp="2x5d1h7ob9deg">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-188" data-mp="qh42f01n4b7t" />
            </button>
          </div>
        </div>

        <div className="mt-7" data-id="element-189" data-mp="cgtbjx0bywmn">
          <BuyButton data-id="element-190" data-mp="ckqt4e79fg4f" />
        </div>
      </div>
    </section>;
}